import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';
import './media-pagination.scss';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      marginTop:20 ,
      marginBottom:20,

    },
  },
}));

export default function MediaPagination() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
        <div className="media-pagination">
            <Pagination count={8} variant="outlined" shape="rounded" />
        </div>
    </div>
  );
}
